import { useState, useEffect, useMemo } from "react";
import { DefaultButton, PrimaryButton, FontSizes, Stack, TextField, Checkbox } from "@fluentui/react";
import { generateClient } from "aws-amplify/api";
import { updateMessageTemplate } from "../graphql/mutations";
import { getMessageTemplate } from "../graphql/queries";

export default function (props) {
  const { messageTemplateId: idProp, messageTemplate: messageTemplateModelProp } = props;

  const initialValues = {
    templateName: "",
    templateBody: "",
  };

  const client = useMemo(() => {
    return generateClient();
  }, []);

  const [templateName, setTemplateName] = useState(initialValues.templateName);
  const [templateBody, setTemplateBody] = useState(initialValues.templateBody);

  const [messageTemplateRecord, setMessageTemplateRecord] = useState(messageTemplateModelProp);

  const resetStateValues = () => {
    const cleanValues = messageTemplateRecord ? { ...initialValues, ...messageTemplateRecord } : initialValues;
    setTemplateName(cleanValues.templateName);
    setTemplateBody(cleanValues.templateBody);
  };

  useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getMessageTemplate,
              variables: {
                id: idProp,
              },
            })
          )?.data?.getMessageTemplate
        : messageTemplateModelProp;
      setMessageTemplateRecord(record);
    };
    queryData();
  }, [idProp, messageTemplateModelProp]);
  useEffect(resetStateValues, [messageTemplateRecord]);

  const submit = async () => {
    let modelFields = {
      templateName: templateName.trim(),
      templateBody: templateBody.trim(),
    };

    try {
      Object.entries(modelFields).forEach(([key, value]) => {
        if (typeof value === "string" && value === "") {
          modelFields[key] = null;
        }
      });
      await client.graphql({
        query: updateMessageTemplate,
        variables: {
          input: {
            id: messageTemplateRecord.id,
            ...modelFields,
          },
        },
      });
      if (props.onSuccess) {
        props.onSuccess(modelFields);
      }
    } catch (err) {
      console.error(err);
      if (props.onError) {
        props.onError(modelFields, err.message);
      }
    }
  };

  return (
    <div className={props.className} style={{ minWidth: 400 }}>
      <div style={{ fontSize: FontSizes.size24, marginBottom: 20 }}>Add Message Template</div>
      <Stack tokens={{ childrenGap: 10 }}>
        <TextField label="Template Name" value={templateName} onChange={(e, v) => setTemplateName(v)} />
        <div style={{ width: 600 }}>
          <TextField label="Message" value={templateBody} onChange={(e, v) => setTemplateBody(v)} multiline rows={8} />
        </div>
        <Stack horizontal={true} horizontalAlign="center" tokens={{ childrenGap: 10, padding: 20 }}>
          <DefaultButton text="Cancel" onClick={props.onCancel} />
          <PrimaryButton text="Submit" onClick={submit} />
        </Stack>
      </Stack>
    </div>
  );
}
